import { lazy } from 'react';
import { Route } from 'react-router-dom';
import Home from 'src/layouts/Home/Home';

const AffiliatePage = lazy(() =>
  import('src/features/affiliate/AffiliatePage/AffiliatePage').then((module) => ({ default: module.AffiliatePage }))
);
const BonusPointsPage = lazy(() => import('src/features/bonus-points/BonusPointsPage/BonusPointsPage'));
const GamesPage = lazy(() => import('src/features/games/GamesPage/GamesPage'));
const JourneysPage = lazy(() => import('src/features/journeys/JourneysPage/JourneysPage'));
const MyAccountPage = lazy(() => import('src/features/my-account/MyAccountPage/MyAccountPage'));
const EditProfilePage = lazy(() => import('src/features/my-account/edit-profile/EditProfilePage'));
const EmailPreferencesPage = lazy(() => import('src/features/my-account/email-preferences/EmailPreferencesPage'));
const SecurityPage = lazy(() => import('src/features/my-account/security/SecurityPage'));
const SupportPage = lazy(() => import('src/features/my-account/support/SupportPage'));
const MyRewardsPage = lazy(() => import('src/features/my-rewards/MyRewardsPage/MyRewardsPage'));
const NotificationInboxPage = lazy(
  () => import('src/features/notifications/NotificationInboxPage/NotificationInboxPage')
);
const NotificationSettingsPage = lazy(
  () => import('src/features/notifications/NotificationSettingsPage/NotificationSettingsPage')
);
const QuestsPage = lazy(() => import('src/features/quests/QuestsPage/QuestsPage'));
const GameSessionGoalsTestPage = lazy(
  () => import('src/features/testing/GameSessionGoalsTestPage/GameSessionGoalsTestPage')
);
const GameSessionLaunchTestPage = lazy(
  () => import('src/features/testing/GameSessionLaunchTestPage/GameSessionLaunchTestPage')
);
const PartnerTermCodes = lazy(() => import('src/features/testing/PartnerTermCodes/PartnerTermCodes'));

// Routes that only authenticated users can access
export function AuthenticatedRoutes() {
  return (
    <>
      <Route path="home" element={<Home />} />
      <Route path="surveys" element={<Home surveysOnly />} />
      <Route path="games" element={<GamesPage />} />
      <Route path="journeys" element={<JourneysPage />} />
      <Route path="journeys/:journeyId" element={<JourneysPage />} />
      <Route path="quests" element={<QuestsPage />} />
      <Route path="my-account" element={<MyAccountPage />} />
      <Route path="my-rewards" element={<MyRewardsPage />} />
      <Route path="notifications" element={<NotificationInboxPage />} />
      <Route path="affiliate" element={<AffiliatePage />} />
      <Route path="bonus-points" element={<BonusPointsPage />} />
      <Route path="my-account/email-preferences" element={<EmailPreferencesPage />} />
      <Route path="my-account/notification-settings" element={<NotificationSettingsPage />} />
      <Route path="my-account/security-and-account" element={<SecurityPage />} />
      <Route path="my-account/edit-profile" element={<EditProfilePage />} />
      <Route path="my-account/support" element={<SupportPage />} />
      <Route path="partner-term-codes" element={<PartnerTermCodes />} />
      <Route path="game-session-goals-test-page" element={<GameSessionGoalsTestPage />} />
      <Route path="game-session-launch-test-page" element={<GameSessionLaunchTestPage />} />
      <Route path="game-session-goals-test" element={<GameSessionGoalsTestPage />} />
      <Route path="game-session-launch-test" element={<GameSessionLaunchTestPage />} />
      {/* Add other protected routes here */}
    </>
  );
}
